export default class NotificacionId {
  #id
  #idPersonalResponsable
  #idPersonalAfectado

  constructor(id, idPersonalResponsable, idPersonalAfectado) {
    this.#id = id
    this.#idPersonalResponsable = idPersonalResponsable
    this.#idPersonalAfectado = idPersonalAfectado
  }

  get value() {
    return this.#id
  }
}
